import { useRequiredContext } from "@redotech/react-util/context";
import { useLoad } from "@redotech/react-util/load";
import { BrandKit, defaultBrandKit } from "@redotech/redo-model/brand-kit";
import {
  getReviewsFormDefault,
  ReviewsFormValue,
} from "@redotech/redo-web/reviews-form/review-form-types";
import { memo } from "react";
import { RedoShopifyRpcClientContext } from "../../client/redo-shopify-rpc-client";
import { ReviewsSurveyModal } from "./reviews-survey-modal";

const formDefault = getReviewsFormDefault(defaultBrandKit);

export const ReviewSurvey = memo(function ReviewSurvey() {
  const rpcClient = useRequiredContext(RedoShopifyRpcClientContext);

  const queryString = location.search;
  const urlParams = new URLSearchParams(queryString);

  const productId = urlParams.get("productId");
  const customerEmail = urlParams.get("email");
  const orderNumber = urlParams.get("orderNumber");
  const reviewId = urlParams.get("reviewId");

  const productInfoLoad = useLoad(async () => {
    return productId
      ? await rpcClient.getProductById({ productId })
      : undefined;
  }, []);

  const orderInfoLoad = useLoad(async () => {
    return orderNumber && customerEmail
      ? await rpcClient.getOrderByNumber({ orderNumber, email: customerEmail })
      : undefined;
  }, [orderNumber, customerEmail]);

  const existingReviewLoad = useLoad(async () => {
    return reviewId && customerEmail
      ? await rpcClient.getReviewById({ reviewId, email: customerEmail })
      : undefined;
  }, [reviewId, customerEmail]);

  const formLoad = useLoad(async () => {
    const reviewForm = await rpcClient.getActiveReviewForm(null);
    if (!reviewForm) {
      return formDefault;
    } else {
      return reviewForm.formData;
    }
  }, []);

  const brandKitLoad = useLoad(async () => {
    if (!formLoad.value) {
      return defaultBrandKit;
    }
    const brandKit = await rpcClient.getBrandKit(null);
    if (formLoad.value?.styles.brandKitEnabled) {
      return formLoad.value?.styles.brandKitOverride || defaultBrandKit;
    } else return brandKit;
  }, [formLoad.value]);

  // REVIEWS-TODO TODO-bcarper I wrote an "as" here because BrandKit and zod are not playing nice -- fix this
  return formLoad.value && productInfoLoad.value && brandKitLoad.value ? (
    <ReviewsSurveyModal
      brandKit={brandKitLoad.value as BrandKit}
      customerEmail={customerEmail}
      existingReview={existingReviewLoad.value}
      orderInfo={orderInfoLoad.value}
      productId={productId}
      productInfo={productInfoLoad.value}
      reviewId={reviewId}
      reviewsFormValue={formLoad.value as ReviewsFormValue}
    />
  ) : null;
});
